import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CarritoContext } from '../../context/CarritoContext';

function Carrito({ item }) {
  const navigate = useNavigate();
  const [cantidad,setCantidad] = useState(0)
  const { productosCarrito } = useContext(CarritoContext);
  useEffect(() => {
    setCantidad(productosCarrito.length)
  },[productosCarrito])
  
  return (
    <div className='relative pr-8'>
      <button onClick={() => navigate('/carrito')} className='relative'>
        {item}
        {cantidad > 0 && (
          <div className='absolute -top-3 -right-3 bg-Rojo text-white rounded-full w-5 h-5 flex items-center justify-center text-2xs font-bold'>
            {cantidad}
          </div>
        )}
      </button>
    </div>
  );
}

export default Carrito;
